import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import ReportList from './ReportList';
import { formatDate } from 'domain/shared/newVacancy';
import { CustomerReport } from 'domain/shared/newProject';
import { EditableListFormShowTemplate } from 'framework/list';

const ReportContext = ({ customerReports, refetch }: { customerReports: CustomerReport[]; refetch: any }) => {
  const sortedReports = [...(customerReports || [])].sort((a, b) => {
    return new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime();
  });

  const initialData = {
    reportData: sortedReports.map((report, index) => {
      return {
        ...report,
        index: sortedReports.length - index,
        formattedPeriod: `Period ${formatDate(report.periodStart)} - ${formatDate(report.periodEnd)}`,
      };
    }),
  };

  const submitFormFunc = async (formData: any) => {
    await refetch();
    return Promise.resolve();
  };

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <FormShowTemplate
        initialData={initialData}
        submitFormFunc={submitFormFunc}
        afterSubmit={{
          message: 'Customer reports have been successfully updated.',
        }}
      >
        <EditableListFormShowTemplate listSource="reportData">
          <ReportList />
        </EditableListFormShowTemplate>
      </FormShowTemplate>
    </ShowSection>
  );
};

export default ReportContext;
